import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';

function GestaltungsprinzipienLernfeld3() {
  const navigate = useNavigate();

  const [levels, setLevels] = useState({
    textquiz: null,
    bildquiz: null,
    audioquiz: null,
  });

  // 🔹 Nur eine Karte darf aktiv sein – bei Klick auf dieselbe wird sie deaktiviert
  const handleSelectLevel = (quizKey, level) => {
    setLevels(prev => {
      if (prev[quizKey] === level) {
        return { textquiz: null, bildquiz: null, audioquiz: null };
      }
      return {
        textquiz: quizKey === 'textquiz' ? level : null,
        bildquiz: quizKey === 'bildquiz' ? level : null,
        audioquiz: quizKey === 'audioquiz' ? level : null,
      };
    });
  };

  // 🔹 Startfunktion pro Karte bleibt gleich …
  // 🔹 Startfunktion pro Karte
  const handleStartClick = quizKey => {
    if (!levels[quizKey]) return;
    const lernfeld = 'Gestaltungsprinzipien3';
    console.log(`Starte Quiz im Lernfeld ${lernfeld} mit Typ ${quizKey} im Level ${levels[quizKey]}`);
    navigate(`/quiz?lernfeld=${lernfeld}&type=${quizKey}&level=${levels[quizKey]}`);
  };

  const getLevelIcon = level => {
  switch (level) {
    case 'easy':
      return process.env.PUBLIC_URL + '/img/icon-bronze.svg';
    case 'medium':
      return process.env.PUBLIC_URL + '/img/icon-silber.svg';
    case 'hard':
      return process.env.PUBLIC_URL + '/img/icon-gold.svg';
    default:
      return '';
  }
};
  return (
    <div
      className="bg-noten-wrapper view"
      style={{
        backgroundImage: `url(${process.env.PUBLIC_URL + '/img/bg-green.svg'})`,
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'bottom left',
        minHeight: '100vh',
        width: '100%',
      }}
    >
      <main className="container" role="main">
        <Link to="/Gestaltungsprinzipien" className="back-btn">← Zurück</Link>
        <h1 className="section-title">GestaltungsprinzipienLernfeld3</h1>

        <div className="grid">

          {/* 🔸 Textquiz */}
          <div className="quizcard card1">
            <div className="card__header">
              <img src={process.env.PUBLIC_URL + '/img/icon-textquiz.svg'} alt="" />
            </div>
            <div className="card__body">
              <h2 className="card__title">Textquiz</h2>
              <p>Wähle deinen Schwierigkeitsgrad:</p>

              {/* Level-Auswahl */}
              <div className="level-select">
                {['easy', 'medium', 'hard'].map(level => (
                  <button
                    key={level}
                    onClick={() => handleSelectLevel('textquiz', level)}
                    className={`level-option ${levels.textquiz === level ? 'active' : ''}`}
                  >
                    <img src={getLevelIcon(level)} alt="" className="level-icon" />
                    {level === 'easy' && (<span className="level-text">Leicht</span>)}
                    {level === 'medium' && (<span className="level-text">Mittel</span>)}
                    {level === 'hard' && (<span className="level-text">Schwer</span>)}
                    <span className="progress-text">1/10</span>
                  </button>
                ))}
              </div>

              {/* Start-Button */}
              <button
                disabled={!levels.textquiz}
                onClick={() => handleStartClick('textquiz')}
                className={`main-btn start-btn ${!levels.textquiz ? 'disabled' : levels.textquiz && 'pulse'}`}
              >
                Start
              </button>
            </div>
          </div>

          

          {/* 🔸 Bildquiz */}
          <div className="quizcard card2">
            <div className="card__header">
              <img src={process.env.PUBLIC_URL + '/img/icon-bildquiz.svg'} alt="" />
            </div>
            <div className="card__body">
              <h2 className="card__title">Bildquiz</h2>
              <p>Wähle deinen Schwierigkeitsgrad:</p>

              {/* Level-Auswahl */}
              <div className="level-select">
                {['easy', 'medium', 'hard'].map(level => (
                  <button
                    key={level}
                    onClick={() => handleSelectLevel('bildquiz', level)}
                    className={`level-option ${levels.bildquiz === level ? 'active' : ''}`}
                  >
                    <img src={getLevelIcon(level)} alt="" className="level-icon" />
                    {level === 'easy' && (<span>Leicht</span>)}
                    {level === 'medium' && (<span>Mittel</span>)}
                    {level === 'hard' && (<span>Schwer</span>)}
                    <span className='progress-text'>3/10</span>
                  </button>
                ))}
              </div>

              {/* Start-Button */}
              <button
                disabled={!levels.bildquiz}
                onClick={() => handleStartClick('bildquiz')}
                className={`main-btn start-btn ${!levels.bildquiz ? 'disabled' : levels.bildquiz && 'pulse'}`}
              >
                Start
              </button>
            </div>
          </div>


          {/* 🔸 Audioquiz */}
          <div className="quizcard card3">
            <div className="card__header">
              <img src={process.env.PUBLIC_URL + '/img/icon-sprachquiz.svg'} alt="" />
            </div>
            <div className="card__body">
              <h2 className="card__title">Audioquiz</h2>
              <p>Wähle deinen Schwierigkeitsgrad:</p>

              {/* Level-Auswahl */}
              <div className="level-select">
                {['easy', 'medium', 'hard'].map(level => (
                  <button
                    key={level}
                    onClick={() => handleSelectLevel('audioquiz', level)}
                    className={`level-option ${levels.audioquiz === level ? 'active' : ''}`}
                  >
                    <img src={getLevelIcon(level)} alt="" className="level-icon" />
                    {level === 'easy' && (<span>Leicht</span>)}
                    {level === 'medium' && (<span>Mittel</span>)}
                    {level === 'hard' && (<span>Schwer</span>)}
                    <span className='progress-text'>3/10</span>
                  </button>
                ))}
              </div>

              {/* Start-Button */}
              <button
                disabled={!levels.audioquiz}
                onClick={() => handleStartClick('audioquiz')}
                className={`main-btn start-btn ${!levels.audioquiz ? 'disabled' : levels.audioquiz && 'pulse'}`}
              >
                Start
              </button>
            </div>
          </div>

          

          
            
          

        </div>
      </main>
    </div>
  );
}

export default GestaltungsprinzipienLernfeld3;